var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2917 2.83398C9.6475 2.83398 4.25 8.23148 4.25 14.8757C4.25 21.5198 9.6475 26.9173 16.2917 26.9173H17V31.1673C23.885 27.8523 28.3333 21.2507 28.3333 14.8757C28.3333 8.23148 22.9358 2.83398 16.2917 2.83398ZM17.7083 23.3757H14.875V20.5423H17.7083V23.3757ZM17.7083 18.4173H14.875C14.875 13.8132 19.125 14.1673 19.125 11.334C19.125 9.77565 17.85 8.50065 16.2917 8.50065C14.7333 8.50065 13.4583 9.77565 13.4583 11.334H10.625C10.625 8.20315 13.1608 5.66732 16.2917 5.66732C19.4225 5.66732 21.9583 8.20315 21.9583 11.334C21.9583 14.8757 17.7083 15.2298 17.7083 18.4173Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIconWhite);
export default __webpack_public_path__ + "static/media/support-icon-white.d73636130906848af23ce7f4b28197cb.svg";
export { ForwardRef as ReactComponent };